import React from 'react'

const EditIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    {...props}
  >
    <path
      d='M0.5 13.5V10.4306L10.0333 0.915308C10.1778 0.782901 10.3373 0.680586 10.5118 0.608364C10.6863 0.536142 10.8699 0.500031 11.0625 0.500031C11.2551 0.500031 11.4417 0.536142 11.6222 0.608364C11.8028 0.680586 11.9593 0.788919 12.0917 0.933364L13.0847 1.94448C13.2292 2.07688 13.3345 2.23336 13.4007 2.41392C13.4669 2.59448 13.5 2.77503 13.5 2.95559C13.5 3.14818 13.4669 3.33174 13.4007 3.50628C13.3345 3.68082 13.2292 3.84031 13.0847 3.98475L3.56944 13.5H0.5ZM11.0444 3.9667L12.0556 2.95559L11.0444 1.94448L10.0333 2.95559L11.0444 3.9667Z'
      fill='currentcolor'
    />
  </svg>
)

export default EditIcon
